import React from "react";
import { useLocation } from "react-router-dom";
import PageLayout from "@/components/layouts/page/PageLayout";
import BackLink from "@/components/BackLink";
import EmailCampaignReportDetail from "../components/campaign-report-detail/EmailCampaignReportDetail";

type EmailCampaignReportLocationState = {
  selectedLocation?: number;
} | null;

const EmailCampaignReportDetailPage = () => {
  const location = useLocation();
  const locationState = location.state as EmailCampaignReportLocationState;
  const selectedLocation = locationState?.selectedLocation;

  return (
    <PageLayout className="participant-dashboard-container mx-0 mx-sm-2">
      <BackLink />
      {/* Header with Title and Controls */}
      <EmailCampaignReportDetail selectedLocation={selectedLocation} />
    </PageLayout>
  );
};

export default EmailCampaignReportDetailPage;
